import { api } from "../lib/api";

// Récupère la configuration notifications du tenant, par rôle.
export const tenant = () =>
  api.get("/notifications/settings/tenant").then((r) => r.data);

// Met à jour la configuration notifications du tenant, par rôle.
export const updateTenant = (payload) =>
  api.put("/notifications/settings/tenant", payload).then((r) => r.data);

// Récupère la configuration notifications plateforme, SaaS admin uniquement.
export const platform = () =>
  api.get("/notifications/settings/platform").then((r) => r.data);

// Met à jour la configuration notifications plateforme, SaaS admin uniquement.
export const updatePlatform = (payload) =>
  api.put("/notifications/settings/platform", payload).then((r) => r.data);

// Récupère les préférences personnelles.
export const me = () =>
  api.get("/notifications/settings/me").then((r) => r.data);

// Met à jour les préférences personnelles.
export const updateMe = (payload) =>
  api.put("/notifications/settings/me", payload).then((r) => r.data);

// Récupère la clé publique VAPID pour le navigateur.
export const pushPublicKey = () =>
  api.get("/notifications/push/public-key").then((r) => r.data);

// Enregistre un abonnement push navigateur.
export const subscribePush = (subscription) =>
  api.post("/notifications/push/subscribe", { subscription }).then((r) => r.data);

// Désactive cet appareil pour le compte courant sans révoquer l'autorisation navigateur.
export const unsubscribePush = (subscription) =>
  api.post("/notifications/push/unsubscribe", { subscription }).then((r) => r.data);

// Envoie un e-mail de test au compte connecté.
export const testEmail = () =>
  api.post("/notifications/email/test").then((r) => r.data);

// Envoie une notification push de test.
export const testPush = () =>
  api.post("/notifications/push/test").then((r) => r.data);
